import React from "react";
import {Card, Descriptions} from "antd";
import CompanyLicenceConfirmationDatatable from "./CompanyLicenceConfirmationDatatable";
import CompanyLicenceList from "./CompanyLicenceList/CompanyLicenceList";

const ThirdStepConfirmation = ({
                                   licenceForm,
                                   availableCompanies,
                                   availableSoftwareProducts,
                                   licenceElements,
                                   darkMode,
                                   primaryColor,
                                   isDeviceSmall
                               }) => {

    const values = licenceForm.getFieldsValue();
    const companyName = values.companyId ? availableCompanies.find(c => c.id === values.companyId).value : '';
    const softwareProduct = values.softwareProductId || '';

    return <>
        <Card>
            <Descriptions
                title="Licence Data"
                bordered
                column={1}
            >
                <Descriptions.Item label="Company">{companyName}</Descriptions.Item>
                <Descriptions.Item label="Software Product">{softwareProduct}</Descriptions.Item>
            </Descriptions>

            <br/>
            <Descriptions
                title="Licence Elements"
                bordered
                column={1}
            >
            </Descriptions>

            {isDeviceSmall ? <CompanyLicenceList darkMode={darkMode} licenceElements={licenceElements}/> :
                <CompanyLicenceConfirmationDatatable licenceElements={licenceElements}/>}
        </Card>
    </>;
};

export default ThirdStepConfirmation;